import { fetchPrivacyPolicy } from './actions/privacy-policy.actions';
import { identity } from 'angular';

const mapStateToThis = ({ session, privacyPolicy }) => {
  const { locale } = session;
  const { content, isLoading, hasError } = privacyPolicy;

  return {
    locale,
    content,
    isLoading,
    hasError,
  };
};

const mapDispatchToThis = {
  fetchPrivacyPolicy,
};

@Inject('$ngRedux', '$sce')
export class RwPrivacyPolicyDialogController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  $onInit() {
    if (this.content.length === 0) this.fetchPrivacyPolicy();
  }
}



// WEBPACK FOOTER //
// ./src/modules/utils/rw-privacy-policy/components/rw-privacy-policy-dialog-controller.js